// extracted by mini-css-extract-plugin
export default {"parent":"SearchPage_parent__96Dje","content":"SearchPage_content__qF0PH"};